export default "__VITE_ASSET__9bhDlfOn__"